export const urlApi = process.env.VUE_APP_API;
export const urlApiSecurity = process.env.VUE_APP_API_SEGURITY;